// https://storage.googleapis.com/mediapipe-assets/face_landmarker.task?generation=1680506159041325
import { simd as detectSimdSupport } from "wasm-feature-detect"
import FaceLandmarkerTask from "./face_landmarker.task?url"
import Solution from "/node_modules/@mediapipe/tasks-vision/wasm/vision_wasm_internal.js?url"
import Wasm from "/node_modules/@mediapipe/tasks-vision/wasm/vision_wasm_internal.wasm?url"
import SolutionNoSimd from "/node_modules/@mediapipe/tasks-vision/wasm/vision_wasm_nosimd_internal.js?url"
import WasmNoSimd from "/node_modules/@mediapipe/tasks-vision/wasm/vision_wasm_nosimd_internal.wasm?url"

export const getDependencies = async () => {
  const isSimdSupported = await detectSimdSupport()

  return [
    {
      url: isSimdSupported ? Wasm : WasmNoSimd,
      type: "application/wasm",
    },
    {
      url: isSimdSupported ? Solution : SolutionNoSimd,
      type: "application/javascript",
    },
    {
      url: FaceLandmarkerTask,
      type: "application/octet-stream",
    },
  ] as const
}
